// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2wj6q","emails":"CreateEditClinics_emails__1dOAH","emailTagLabel":"CreateEditClinics_emailTagLabel__1AJR1"};